import { render, staticRenderFns } from "./couponDataTable.vue?vue&type=template&id=4993f501&scoped=true&class=full-height"
import script from "./couponDataTable.vue?vue&type=script&lang=js"
export * from "./couponDataTable.vue?vue&type=script&lang=js"
import style0 from "./couponDataTable.vue?vue&type=style&index=0&id=4993f501&lang=css"
import style1 from "./couponDataTable.vue?vue&type=style&index=1&id=4993f501&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4993f501",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitHub\\ita.GroupTravel.Website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4993f501')) {
      api.createRecord('4993f501', component.options)
    } else {
      api.reload('4993f501', component.options)
    }
    module.hot.accept("./couponDataTable.vue?vue&type=template&id=4993f501&scoped=true&class=full-height", function () {
      api.rerender('4993f501', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/appManage/components/couponDataTable.vue"
export default component.exports